import React from 'react'
import './student-status-information-popup.css'


const StudentStatusInformationPopup = () => {
    return(
        <div className="status-popup">
            <div className="status-popup-triangle"></div>
            <div className="status-desc-wrapper first-info-wrapper">
                <h3 className="status-title">Active</h3>
                <p className="status-desc">When a family has at least one student currently taking lessons.</p>
            </div>
            <div className="status-desc-wrapper">
                <h3 className="status-title">Being Onboarded</h3>
                <p className="status-desc">When a family has asked about lessons and is in the process of signing up.</p>
            </div>
            <div className="status-desc-wrapper">
                <h3 className="status-title">Taking a Break</h3>
                <p className="status-desc">When a family has said they are taking a break from lessons.</p>
            </div>
            <div className="status-desc-wrapper">
                <h3 className="status-title">Left the School</h3>
                <p className="status-desc">When a family has left permanently for a specific reason.</p>
            </div>
            <div className="status-desc-wrapper">
                <h3 className="status-title">Inquired</h3>
                <p className="status-desc">When a family asked about lessons and decided not to sign up or disappeared.</p>
            </div>
        </div>
    )
}

export default StudentStatusInformationPopup